// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "assets/js/" + chunkId + "." + {"48":"84a7a1e7","64":"3e730f09","80":"b315be72","205":"83cf6eba","694":"6e4228a5","773":"aced1946","850":"575da777","985":"2f09bf15","996":"22f6d470"}[chunkId] + ".js";
};